<template>
    <div class="auth-background">
      <card-auth />

      <div
        class="auth-logo"
        v-html="logo"
      />
    </div>
</template>

<script>
/**
 * Корневой компонент модуля PageAuth
 * @module PageAuth/Component/App
 * */

import logo from 'Images/icon/logo.svg'
import CardAuth from 'PageAuth/components/CardAuth.vue'

export default {
  name: 'PageAuth',
  components: {
    CardAuth
  },
  data: () => ({
    logo
  })
}
</script>

<style lang="scss" scoped>
.auth {
    &-background {
      background-color: #ffffff;
      height: 100vh;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }

    &-logo {
      position: absolute;
      top: 65px;
      left: 65px;
      width: 120px;
      height: 120px;
    }
}
</style>
